export default "__VITE_ASSET__ChpAtI4r__"